import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  ${common.gql.dms.data.fragments.variable.DOC}
  fragment FragmentMosaicWidget on MosaicWidget {
    id
    alias
    name
    query
    description
    variables {
      ...FragmentVariable
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicWidgetFragment,
  ents.core.mosaic.Widget
>({
  alias: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  description: transformers.PASS_THROUGH,
  id: transformers.PASS_THROUGH,
  name: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  query: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.json({ onNullish: 'preserve' }),
    ents.core.mosaic.Widget.Query.assertIsQuery,
    { warnOnly: true },
  ),
  variables: {
    usingFullInput: graphql.transformers.OUT.default(
      graphql.transformers.OUT.select(
        'variables',
        graphql.transformers.OUT.list(
          common.gql.dms.data.fragments.variable.TRANSFORMER,
          { onNullish: 'remove' },
        ),
      ),
      [],
    ),
  },
})
